module.exports = __webpack_public_path__ + "static/img/rect-bg.c11fda3a.webp";